<template>
    <div>
        <div class="title">SMS Campaign Overview</div>
        <sms-campaign-details v-if="campaign.id" :campaign="campaign" />
    </div>
</template>

<script>
    import SmsCampaignDetails from '@/components/SMSCampaignDetails.vue'
    import smsCampaignService from '@/services/sms-campaign-service'
    export default {
        components: { SmsCampaignDetails },
        data() {
            return {
                campaign: {}
            }
        },
        created() {
            this.fetchSMSCampaignById(this.$route.params.campaignId)
        },
        methods: {
            fetchSMSCampaignById(id) {
                smsCampaignService.getSMSCampaignById(id).then(resp => {
                    this.campaign = resp.data
                })
            }
        }
    }
</script>

<style scoped>
.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
}
</style>
